import React from 'react';
import Dialog from '@mui/material/Dialog';
import { DashboardIcon } from './DashboardIcon';
import { IconButton } from './IconButton';

type ModalShellProps = {
  labelledBy: string;
  onClose: () => void;
  title: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
};

export function ModalShell({
  children,
  className = 'signup-dialog',
  headerClassName = 'signup-dialog-head',
  labelledBy,
  onClose,
  title,
}: ModalShellProps) {
  return (
    <Dialog
      aria-labelledby={labelledBy}
      onClose={onClose}
      open
      slotProps={{
        backdrop: { className: 'modal-backdrop' },
        paper: { className },
      }}
    >
      <section>
        <div className={headerClassName}>
          <div>{title}</div>
          <IconButton ariaLabel="Close dialog" onClick={onClose}>
            <DashboardIcon type="close" />
          </IconButton>
        </div>
        {children}
      </section>
    </Dialog>
  );
}
